import type { FareConfig, VehicleType } from '@raahi/shared';

interface DemoDriver {
  id: string;
  name: string;
  rating: number;
  vehicle: { make: string; model: string; plate: string; color: string; type: VehicleType };
  position: { lat: number; lng: number };
}

export const DEMO_DRIVERS: DemoDriver[] = [
  { id: 'demo-d-1', name: 'Imran Baig', rating: 4.9, vehicle: { make: 'Suzuki', model: 'Mehran', plate: 'AKL-734', color: 'White', type: 'economy' }, position: { lat: 24.8642, lng: 67.0099 } },
  { id: 'demo-d-2', name: 'Owais Memon', rating: 4.8, vehicle: { make: 'Toyota', model: 'Corolla', plate: 'BFL-201', color: 'Silver', type: 'premium' }, position: { lat: 24.8731, lng: 67.0322 } },
  { id: 'demo-d-3', name: 'Faisal Sheikh', rating: 4.7, vehicle: { make: 'Honda', model: 'CD 70', plate: 'KFV-118', color: 'Red', type: 'bike' }, position: { lat: 24.8511, lng: 67.0241 } },
  { id: 'demo-d-4', name: 'Adeel Rauf', rating: 4.8, vehicle: { make: 'Suzuki', model: 'Cultus', plate: 'AVT-559', color: 'Grey', type: 'economy' }, position: { lat: 24.8849, lng: 67.0775 } },
];

export const DEMO_FARE_CONFIG: Record<VehicleType, FareConfig> = {
  bike: { vehicleType: 'bike', base: 80, perKm: 25, perMin: 6, minFare: 120 },
  economy: { vehicleType: 'economy', base: 150, perKm: 55, perMin: 12, minFare: 250 },
  premium: { vehicleType: 'premium', base: 250, perKm: 95, perMin: 18, minFare: 450 },
};

export interface DemoHistoryEntry {
  id: string;
  status: 'completed' | 'cancelled';
  vehicleType: VehicleType;
  pickup: { lat: number; lng: number; label: string };
  drop: { lat: number; lng: number; label: string };
  distanceKm: number;
  durationMin: number;
  fare: { base: number; distance: number; duration: number; surge: number; total: number };
  paymentMethod: 'cash' | 'card';
  requestedAt: string;
  endedAt: string;
}

const oneDay = 24 * 60 * 60 * 1000;

export const DEMO_HISTORY: DemoHistoryEntry[] = [
  {
    id: 'demo-trip-1',
    status: 'completed',
    vehicleType: 'economy',
    pickup: { lat: 24.8607, lng: 67.0011, label: 'Saddar' },
    drop: { lat: 24.8138, lng: 67.0299, label: 'Clifton' },
    distanceKm: 6.4,
    durationMin: 18,
    fare: { base: 150, distance: 352, duration: 216, surge: 0, total: 718 },
    paymentMethod: 'cash',
    requestedAt: new Date(Date.now() - 2 * oneDay).toISOString(),
    endedAt: new Date(Date.now() - 2 * oneDay + 18 * 60_000).toISOString(),
  },
  {
    id: 'demo-trip-2',
    status: 'completed',
    vehicleType: 'premium',
    pickup: { lat: 24.8779, lng: 67.0671, label: 'Dolmen Mall Tariq Road' },
    drop: { lat: 24.9008, lng: 67.1681, label: 'Jinnah International Airport' },
    distanceKm: 14.2,
    durationMin: 32,
    fare: { base: 250, distance: 1349, duration: 576, surge: 0, total: 2175 },
    paymentMethod: 'card',
    requestedAt: new Date(Date.now() - 5 * oneDay).toISOString(),
    endedAt: new Date(Date.now() - 5 * oneDay + 32 * 60_000).toISOString(),
  },
  {
    id: 'demo-trip-3',
    status: 'completed',
    vehicleType: 'bike',
    pickup: { lat: 24.8949, lng: 67.0775, label: 'Gulshan-e-Iqbal Block 6' },
    drop: { lat: 24.9056, lng: 67.0822, label: 'Gulshan-e-Iqbal Block 10' },
    distanceKm: 1.8,
    durationMin: 7,
    fare: { base: 80, distance: 45, duration: 42, surge: 0, total: 167 },
    paymentMethod: 'cash',
    requestedAt: new Date(Date.now() - 11 * oneDay).toISOString(),
    endedAt: new Date(Date.now() - 11 * oneDay + 7 * 60_000).toISOString(),
  },
];
